import React, { Component } from 'react';

import DatePicker from './../DatePicker';

const Birthday = (props) => (
    <DatePicker label="出生日期" name="birthday" {...props} />
);

export default Birthday;